// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".status::before {\n  content: \"\";\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  margin: 0 5px 0 0;\n}\n\n.status[data-status=\"none\"]::before {\n  background-color: #2fcc66;\n}\n\n.status[data-status=\"minor\"]::before {\n  background-color: #f1c40f;\n}\n\n.status[data-status=\"major\"]::before {\n  background-color: #e67e22;\n}\n\n.status[data-status=\"critical\"]::before {\n  background-color: #e74c3c;\n}\n", ""]);
// Exports
module.exports = exports;
